<template>
    <div class="kt-form__actions">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        
    }
}
</script>